<div class="d-flex flex-column" style="gap: 1rem;">

  <!-- Franja fija con los tramos ya elegidos -->
  <div *ngIf="selectedLegs[0] || finalized" class="d-flex flex-column" style="gap: 8px;">
    <ng-container *ngFor="let leg of legs; let i = index">
      <div
        *ngIf="isLegSelected(i)"
        class="d-flex align-items-center justify-content-between"
        style="border: 1px solid #00d398; background-color: #f0fdf9; border-radius: 8px; padding: 10px 16px;"
      >
        <div class="d-flex align-items-center" style="gap: 14px;">
          <span style="font-family: 'Rubik'; font-size: 12px; font-weight: 700; color: #00a67a; text-transform: uppercase;">
            {{ legLabels[i] }}
          </span>
          <span style="font-family: 'Rubik'; font-size: 13px; color: #333;">
            {{ getFirstSegment(selectedLegs[i].offer)?.departure?.airport }}
            {{ formatTime(getFirstSegment(selectedLegs[i].offer)?.departure?.dateTime) }}
            &rarr;
            {{ getLastSegment(selectedLegs[i].offer)?.arrival?.airport }}
            {{ formatTime(getLastSegment(selectedLegs[i].offer)?.arrival?.dateTime) }}
          </span>
        </div>

        <button
          *ngIf="canChangeLeg(i)"
          type="button"
          (click)="changeLeg(i)"
          style="background: none; border: none; color: #00a67a; font-size: 13px; font-weight: 600; text-decoration: underline;"
        >
          Cambiar
        </button>
      </div>
    </ng-container>
  </div>

  <!-- Selección finalizada -->
  <div *ngIf="finalized" class="text-center" style="padding: 1.5rem; background-color: #f0fdf9; border-radius: 8px;">
    <p style="margin-bottom: 0; font-family: 'Rubik'; font-size: 15px; font-weight: 600; color: #00a67a;">
      ¡Listo! Se agregaron {{ legs.length }} vuelo{{ legs.length !== 1 ? 's' : '' }} al itinerario.
    </p>
  </div>

  <!-- Selección del tramo activo -->
  <ng-container *ngIf="!finalized">
    <h5 style="font-weight: 600; margin-bottom: 0;">
      Elegí tu vuelo de {{ activeLegLabel }}
    </h5>

    <div *ngIf="loadingLeg" class="text-center" style="padding: 2rem 0; color: #666;">
      Buscando vuelos...
    </div>

    <div *ngIf="!loadingLeg && legError" class="text-center" style="padding: 1.5rem; background-color: #fff3e0; border-radius: 8px;">
      <p style="margin-bottom: 10px; font-size: 14px;">No pudimos buscar los vuelos de este tramo.</p>
      <button
        type="button"
        class="btn"
        (click)="changeLeg(activeLegIndex)"
        style="background-color: #00d398; color: white; border-radius: 50rem; padding: 0.4rem 1.2rem;"
      >
        Reintentar
      </button>
    </div>

    <div *ngIf="!loadingLeg && !legError && offersForActiveLeg.length === 0" class="text-center" style="padding: 1.5rem; color: #666;">
      No encontramos vuelos para este tramo.
    </div>

    <ng-container *ngIf="!loadingLeg && !legError">
      <div *ngFor="let offer of offersForActiveLeg; let i = index" class="mb-3">
        <usb-base-result
          [result]="offer"
          [payload]="activeLegPayload"
          [arrayResults]="arrayResults"
          [index]="i"
          [currencies]="currencies"
          [currencyAgency]="currencyAgency"
          [paymentAgencyActive]="paymentAgencyActive"
          [clientsSettingAppBooking]="clientsSettingAppBooking"
          [qtyProductValid]="qtyProductValid"
          [deferFlightCreation]="true"
          (flightFareSelectedForLeg)="onLegChosen($event)"
        >
        </usb-base-result>
      </div>
    </ng-container>
  </ng-container>
</div>
